import * as React from "react";
import OpQuotesHeadingDsk, { IOpQuotesHeadingDskProps } from "../partials/opQuotesHeadingDsk";
import OpMarketDepthList from "../partials/opMarketDepthList";
import "../../../../../assets/scss/components/toc/orderPlacement/opQuotes/opQuotesTab.scss";
import moment from "moment";
import { toINR } from "../../../../service/numberFormat";

export interface IOpQuotesNfoTabProps {
	quoteData: any;
	quoteDataExtra: any;
}

const OpQuotesNfoTab: React.FC<IOpQuotesNfoTabProps> = props => {
	const [showMarketDepth, setShowMarketDepth] = React.useState(false);
	const quotesHeadingProps: IOpQuotesHeadingDskProps = {
		dpNm: props.quoteDataExtra.Name,
		dateRange: `${props.quoteDataExtra.OpenDate ? moment(props.quoteDataExtra.OpenDate).format("DD MMM") : "--"} - ${
			props.quoteDataExtra.CloseDate ? moment(props.quoteDataExtra.CloseDate).format("DD MMM") : "--"
		}`
	};

	return (
		<section className="quotes_cont ofs">
			<div className="quotes_cont_row">
				<OpQuotesHeadingDsk {...quotesHeadingProps} />

				<div className="left_side_ofs">
					<button className="change_btn" onClick={console.log}>
						Change
					</button>

					<div className="blue_btn_cont ib">
						<button className="blue_btn" onClick={() => setShowMarketDepth(true)}>
							Market Depth
						</button>

						{showMarketDepth && (
							<>
								<div className="popup_overlay" onClick={() => setShowMarketDepth(false)} />
								<div className="popup">
									<OpMarketDepthList
										data={[
											{ label: "Fund Class", value: "Equity" },
											{ label: "Min Investment", value: toINR(props.quoteData.MinPurAmt) },
											{ label: "Entry Load", value: props.quoteDataExtra.EntryLoad || "NA" },
											{ label: "Lock in Period", value: props.quoteDataExtra.LockinPeriod || "NA" },
											{ label: "Risk", value: props.quoteDataExtra.RiskCategory || "NA" }
										]}
									/>
								</div>
							</>
						)}
					</div>
				</div>
			</div>
		</section>
	);
};

export default OpQuotesNfoTab;
